import(/* webpackMode: "eager" */ "/codebuild/output/src509251388/src/skop-manage/src/app/global-error.tsx");
